/**
 * Returns left or right based on expression result
 *
 * @param {(() => boolean) | boolean | Object | null | undefined} expression
 * @param {(() => any) | any} left
 * @param {(() => any) | any} right
 * @returns
 */
export function ternary(expression, left, right = '') {
  const expressionResult = typeof expression === 'function' ? expression() : !!expression;
  const result = expressionResult ? left : right;

  return typeof result === 'function' ? result() : result;
}
